import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-b from-gray-100 to-gray-200 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="flex flex-col items-center text-center bg-white shadow-2xl rounded-3xl p-10 w-full max-w-md border border-gray-100"
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mb-4"
        >
          <span className="text-red-500 text-5xl font-bold">!</span>
        </motion.div>

        <h1 className="text-3xl font-extrabold text-gray-800 mb-2">
          {t("NotFoundPageErrorMsg")}
        </h1>

        <p className="text-gray-600 text-base mb-6">
          {t("The page you're looking for doesn't exist or has been moved.")}
        </p>

        <button
          onClick={() => navigate("/main/projects")}
          className="mt-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-2xl shadow-md transition-all"
        >
          {t("Go Project Menu")}
        </button>
      </motion.div>
    </div>
  );
}
